import type { IconProps } from '../types/IconProps.ts';
export const ClipboardCheck: IconProps = {
    name: 'ClipboardCheck',
    children: [
        `<path d="M8 4H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />`,
        `<rect width="8" height="4" x="8" y="2" rx="2" />`,
        `<path d="m9 14.12 1.98 1.98q.14.12.28 0L15 12" />`,
    ]
};